import { render, staticRenderFns } from "./statisticsView.vue?vue&type=template&id=d20c2a98"
import script from "./statisticsView.vue?vue&type=script&lang=js"
export * from "./statisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports